import {
  createLeadsInCalculationTablesSlice,
  LeadsInCalculationTablesSlice,
} from "@/features/calculations/slices/leadsInCalculation";
import {
  createSelectedItemsSlice as createSelectedItemsTariffSlice,
  SelectedItemsSlice as SelectedItemsTariffSlice,
} from "@/features/tariffs/slices/selectedItems";
import {
  createSelectedItemsSlice as createSelectedItemsUserSlice,
  SelectedItemsSlice as SelectedItemsUserSlice,
} from "@/features/users/slices/selectedItems";
import { create } from "@/lib/zustand-create";
import { createModalsSlice, ModalsSlice } from "./slices/modals";
import { createTablesSlice, TablesSlice } from "./slices/tables";
import {
  createDateParamsSlice,
  DateParamsSlice,
} from "@/features/reportsPortfolio/slices/dateParams";
import {
  NotificationsSlice,
  updateNotificationsSlice,
} from "@/components/notifications/slices/notifications";
import {
  createReportParamsSlice,
  ReportParamsSlice,
} from "@/features/reports/slices/reportDateParams";

export type Store = TablesSlice &
  ModalsSlice &
  SelectedItemsTariffSlice &
  SelectedItemsUserSlice &
  LeadsInCalculationTablesSlice &
  DateParamsSlice &
  ReportParamsSlice &
  NotificationsSlice;

export const useStore = create<Store>((...a) => ({
  ...createTablesSlice(...a),
  ...createModalsSlice(...a),
  ...createSelectedItemsTariffSlice(...a),
  ...createSelectedItemsUserSlice(...a),
  ...createLeadsInCalculationTablesSlice(...a),
  ...createDateParamsSlice(...a),
  ...createReportParamsSlice(...a),
  ...updateNotificationsSlice(...a),
}));
